enum ChatPage {
  MESSAGES,
  MEDIA,
  SNIPPET,
  CONTACTS,
  MENTION,
  JOB
}

export default ChatPage;